/**
 * Verwijdert een ingebedde "Producten & Diensten"-producttabel uit klantgerichte offerte-inhoud.
 * (Zelfde logica als server/utils/stripProductenSection.js — wijzig beide bij aanpassingen.)
 */

const HEADING_RE = /^Producten\s*(?:&|&amp;)\s*Diensten\s*$/i;

export function stripProductenTableFromHtml(html) {
  if (!html || typeof html !== 'string') return html;
  const block = new RegExp(
    '<h[23][^>]*>\\s*Producten\\s*(?:&|&amp;)\\s*Diensten\\s*</h[23]>\\s*<table[\\s\\S]*?</table>',
    'gi'
  );
  return html.replace(block, '').trim();
}

export function stripProductenPlainTableBlock(text) {
  if (!text || typeof text !== 'string') return text;
  const lines = text.split(/\r?\n/);
  const out = [];
  let i = 0;
  while (i < lines.length) {
    const trimmed = lines[i].trim();
    if (HEADING_RE.test(trimmed)) {
      i += 1;
      while (i < lines.length && lines[i].trim() === '') i += 1;
      if (i < lines.length && /OMSCHRIJVING/i.test(lines[i])) {
        i += 1;
      }
      while (i < lines.length) {
        const L = lines[i];
        const t = L.trim();
        if (t === '') break;
        const looksRow =
          L.includes('\t') ||
          (L.includes('€') && /€\s*[\d.,]+/.test(L) && L.split(/€\s*[\d.,]+/g).length >= 2) ||
          /^Product\s*\(/i.test(t);
        if (looksRow) {
          i += 1;
          continue;
        }
        break;
      }
      while (i < lines.length && lines[i].trim() === '') i += 1;
      continue;
    }
    out.push(lines[i]);
    i += 1;
  }
  return out.join('\n').replace(/\n{3,}/g, '\n\n').trim();
}

export function stripProductenSectionFromContent(value) {
  if (!value || typeof value !== 'string') return value;
  let s = stripProductenTableFromHtml(value);
  s = stripProductenPlainTableBlock(s);
  return s;
}
